// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html,
body,
#root {
  margin: 0;
  padding: 0;
  width: 100%;
  min-height: 100%;
  overflow-x: hidden;
  background: #eef1f6;
}

body {
  overflow-y: auto;
}

html,
body {
  -ms-overflow-style: none;
  scrollbar-width: none;
}

html::-webkit-scrollbar,
body::-webkit-scrollbar {
  width: 0;
  height: 0;
}

:root {
  --nav-height: 100px;
}

.common-nav {
  position: fixed !important;
  top: env(safe-area-inset-top);
  left: 0;
  right: 0;
  width: 100%;
  z-index: 9999;
  background: #f4f5f7;
  border-bottom: 1px solid #cfd7e3;
  box-shadow: 0 1px 0 rgba(255, 255, 255, 0.85) inset;
  overflow: visible;
}

.app-content {
  position: relative;
  padding-top: calc(var(--nav-height) + env(safe-area-inset-top));
}

.app-content--no-nav {
  padding-top: 0;
}

html.dost-page,
body.dost-page,
body.dost-page #root {
  background: #ffffff;
}

body.dost-page {
  overflow: hidden;
}

body.dost-page .app-content,
body.dost-page .app-content--no-nav {
  padding-top: 0 !important;
  min-height: 100vh;
}

body.dost-page .common-nav,
body.dost-page .common-footer,
body.dost-page .call-float,
body.dost-page .whatsapp-float {
  display: none !important;
}

.common-nav__inner {
  width: 100%;
  margin: 0;
  padding: 0 18px 0 6px;
  box-sizing: border-box;
  min-height: var(--nav-height);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 28px;
}

.common-nav__brand {
  min-width: 250px;
  color: #111827;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  gap: 12px;
}

.common-nav__logo-slot {
  width: 110px;
  height: 110px;
  border-radius: 10px;
  object-fit: contain;
  display: block;
}

.common-nav__brand-text {
  font-size: 1.55rem;
  font-weight: 800;
  letter-spacing: 0.01em;
  white-space: nowrap;
}

.common-nav__links {
  display: flex;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: center;
  gap: 14px;
  overflow-x: hidden;
}

.common-nav__links a {
  color: #161c28;
  text-decoration: none;
  white-space: nowrap;
  font-size: 1.2rem;
  font-weight: 700;
  padding: 12px 16px;
  border-radius: 14px;
  transition: color 0.2s ease, background-color 0.2s ease, box-shadow 0.2s ease;
}

.common-nav__links a:hover {
  background: #eceff5;
}

.common-nav__links a.active {
  color: #472347;
  background: #bcf5bc;
  box-shadow: inset 0 0 0 1px greenyellow;
}

.common-nav__actions {
  min-width: 220px;
  display: flex;
  justify-content: flex-end;
}

.common-nav__menu-btn {
  display: none;
  width: 44px;
  height: 44px;
  border-radius: 10px;
  border: 1px solid #cdd5e2;
  background: #ffffff;
  color: #162035;
  font-size: 1.35rem;
  font-weight: 700;
  cursor: pointer;
}

.common-nav__overlay {
  position: fixed;
  inset: 0;
  background: rgba(8, 18, 34, 0.45);
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.2s ease;
  z-index: 58;
}

.common-nav__overlay.open {
  opacity: 1;
  pointer-events: auto;
}

.common-nav__drawer {
  position: fixed;
  top: 0;
  right: 0;
  width: 280px;
  height: 100vh;
  background: #f7f8fb;
  border-left: 1px solid #d5deea;
  box-shadow: -8px 0 20px rgba(0, 0, 0, 0.16);
  transform: translateX(100%);
  transition: transform 0.24s ease;
  z-index: 60;
  padding: 14px 14px 20px;
  pointer-events: none;
}

.common-nav__drawer.open {
  transform: translateX(0);
  pointer-events: auto;
}

.common-nav__drawer-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 1.02rem;
  font-weight: 700;
  color: #111827;
  padding: 8px 4px 12px;
  border-bottom: 1px solid #d6deea;
}

.common-nav__drawer-head button {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  border: 1px solid #cbd5e1;
  background: #ffffff;
  cursor: pointer;
  font-size: 1.2rem;
  line-height: 1;
}

.common-nav__drawer-links {
  display: grid;
  gap: 6px;
  margin-top: 12px;
}

.common-nav__drawer-links a {
  text-decoration: none;
  color: #1b2539;
  font-weight: 600;
  font-size: 0.95rem;
  padding: 10px 12px;
  border-radius: 10px;
}

.common-nav__drawer-links a.active {
  background: #d7c1de;
  color: #472347;
}

@media (max-width: 820px) {
  :root {
    --nav-height: 84px;
  }

  .app-content {
    padding-top: calc(var(--nav-height) + env(safe-area-inset-top));
  }

  .common-nav {
    border-bottom: 1px solid #d7deea;
  }

  .common-nav__inner {
    width: 100%;
    margin: 0;
    min-height: var(--nav-height);
    padding: 8px 14px;
    gap: 10px;
  }

  .common-nav__brand {
    min-width: 0;
    gap: 0;
  }

  .common-nav__logo-slot {
    width: 88px;
    height: 76px;
    border-radius: 14px;
  }

  .common-nav__brand-text,
  .common-nav__links {
    display: none;
  }

  .common-nav__actions {
    min-width: 0;
    margin-left: auto;
    display: flex;
    justify-content: flex-end;
  }

  .common-nav__menu-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 44px;
    height: 44px;
    border-radius: 10px;
  }

  .common-nav__overlay {
    z-index: 1100;
  }

  .common-nav__drawer {
    top: 0;
    right: 0;
    width: min(72vw, 280px);
    z-index: 1200;
    padding: 14px 14px 20px;
  }
}
`, "",{"version":3,"sources":["webpack://./components/navbar.css"],"names":[],"mappings":"AAAA;;;EAGE,SAAS;EACT,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;;EAEE,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,6BAA6B;EAC7B,OAAO;EACP,QAAQ;EACR,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,gCAAgC;EAChC,mDAAmD;EACnD,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,+DAA+D;AACjE;;AAEA;EACE,cAAc;AAChB;;AAEA;;;EAGE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;;;;EAIE,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,SAAS;EACT,qBAAqB;EACrB,sBAAsB;EACtB,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,6EAA6E;AAC/E;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,uCAAuC;AACzC;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,iCAAiC;EACjC,UAAU;EACV,oBAAoB;EACpB,6BAA6B;EAC7B,WAAW;AACb;;AAEA;EACE,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,2CAA2C;EAC3C,2BAA2B;EAC3B,gCAAgC;EAChC,WAAW;EACX,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,wBAAwB;EACxB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,+DAA+D;EACjE;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,WAAW;IACX,SAAS;IACT,6BAA6B;IAC7B,iBAAiB;IACjB,SAAS;EACX;;EAEA;IACE,YAAY;IACZ,MAAM;EACR;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;EACrB;;EAEA;;IAEE,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,iBAAiB;IACjB,aAAa;IACb,yBAAyB;EAC3B;;EAEA;IACE,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,MAAM;IACN,QAAQ;IACR,uBAAuB;IACvB,aAAa;IACb,uBAAuB;EACzB;AACF","sourcesContent":["html,\nbody,\n#root {\n  margin: 0;\n  padding: 0;\n  width: 100%;\n  min-height: 100%;\n  overflow-x: hidden;\n  background: #eef1f6;\n}\n\nbody {\n  overflow-y: auto;\n}\n\nhtml,\nbody {\n  -ms-overflow-style: none;\n  scrollbar-width: none;\n}\n\nhtml::-webkit-scrollbar,\nbody::-webkit-scrollbar {\n  width: 0;\n  height: 0;\n}\n\n:root {\n  --nav-height: 100px;\n}\n\n.common-nav {\n  position: fixed !important;\n  top: env(safe-area-inset-top);\n  left: 0;\n  right: 0;\n  width: 100%;\n  z-index: 9999;\n  background: #f4f5f7;\n  border-bottom: 1px solid #cfd7e3;\n  box-shadow: 0 1px 0 rgba(255, 255, 255, 0.85) inset;\n  overflow: visible;\n}\n\n.app-content {\n  position: relative;\n  padding-top: calc(var(--nav-height) + env(safe-area-inset-top));\n}\n\n.app-content--no-nav {\n  padding-top: 0;\n}\n\nhtml.dost-page,\nbody.dost-page,\nbody.dost-page #root {\n  background: #ffffff;\n}\n\nbody.dost-page {\n  overflow: hidden;\n}\n\nbody.dost-page .app-content,\nbody.dost-page .app-content--no-nav {\n  padding-top: 0 !important;\n  min-height: 100vh;\n}\n\nbody.dost-page .common-nav,\nbody.dost-page .common-footer,\nbody.dost-page .call-float,\nbody.dost-page .whatsapp-float {\n  display: none !important;\n}\n\n.common-nav__inner {\n  width: 100%;\n  margin: 0;\n  padding: 0 18px 0 6px;\n  box-sizing: border-box;\n  min-height: var(--nav-height);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 28px;\n}\n\n.common-nav__brand {\n  min-width: 250px;\n  color: #111827;\n  text-decoration: none;\n  display: inline-flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.common-nav__logo-slot {\n  width: 110px;\n  height: 110px;\n  border-radius: 10px;\n  object-fit: contain;\n  display: block;\n}\n\n.common-nav__brand-text {\n  font-size: 1.55rem;\n  font-weight: 800;\n  letter-spacing: 0.01em;\n  white-space: nowrap;\n}\n\n.common-nav__links {\n  display: flex;\n  flex-wrap: nowrap;\n  justify-content: center;\n  align-items: center;\n  gap: 14px;\n  overflow-x: hidden;\n}\n\n.common-nav__links a {\n  color: #161c28;\n  text-decoration: none;\n  white-space: nowrap;\n  font-size: 1.2rem;\n  font-weight: 700;\n  padding: 12px 16px;\n  border-radius: 14px;\n  transition: color 0.2s ease, background-color 0.2s ease, box-shadow 0.2s ease;\n}\n\n.common-nav__links a:hover {\n  background: #eceff5;\n}\n\n.common-nav__links a.active {\n  color: #472347;\n  background: #bcf5bc;\n  box-shadow: inset 0 0 0 1px greenyellow;\n}\n\n.common-nav__actions {\n  min-width: 220px;\n  display: flex;\n  justify-content: flex-end;\n}\n\n.common-nav__menu-btn {\n  display: none;\n  width: 44px;\n  height: 44px;\n  border-radius: 10px;\n  border: 1px solid #cdd5e2;\n  background: #ffffff;\n  color: #162035;\n  font-size: 1.35rem;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.common-nav__overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(8, 18, 34, 0.45);\n  opacity: 0;\n  pointer-events: none;\n  transition: opacity 0.2s ease;\n  z-index: 58;\n}\n\n.common-nav__overlay.open {\n  opacity: 1;\n  pointer-events: auto;\n}\n\n.common-nav__drawer {\n  position: fixed;\n  top: 0;\n  right: 0;\n  width: 280px;\n  height: 100vh;\n  background: #f7f8fb;\n  border-left: 1px solid #d5deea;\n  box-shadow: -8px 0 20px rgba(0, 0, 0, 0.16);\n  transform: translateX(100%);\n  transition: transform 0.24s ease;\n  z-index: 60;\n  padding: 14px 14px 20px;\n  pointer-events: none;\n}\n\n.common-nav__drawer.open {\n  transform: translateX(0);\n  pointer-events: auto;\n}\n\n.common-nav__drawer-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  font-size: 1.02rem;\n  font-weight: 700;\n  color: #111827;\n  padding: 8px 4px 12px;\n  border-bottom: 1px solid #d6deea;\n}\n\n.common-nav__drawer-head button {\n  width: 32px;\n  height: 32px;\n  border-radius: 8px;\n  border: 1px solid #cbd5e1;\n  background: #ffffff;\n  cursor: pointer;\n  font-size: 1.2rem;\n  line-height: 1;\n}\n\n.common-nav__drawer-links {\n  display: grid;\n  gap: 6px;\n  margin-top: 12px;\n}\n\n.common-nav__drawer-links a {\n  text-decoration: none;\n  color: #1b2539;\n  font-weight: 600;\n  font-size: 0.95rem;\n  padding: 10px 12px;\n  border-radius: 10px;\n}\n\n.common-nav__drawer-links a.active {\n  background: #d7c1de;\n  color: #472347;\n}\n\n@media (max-width: 820px) {\n  :root {\n    --nav-height: 84px;\n  }\n\n  .app-content {\n    padding-top: calc(var(--nav-height) + env(safe-area-inset-top));\n  }\n\n  .common-nav {\n    border-bottom: 1px solid #d7deea;\n  }\n\n  .common-nav__inner {\n    width: 100%;\n    margin: 0;\n    min-height: var(--nav-height);\n    padding: 8px 14px;\n    gap: 10px;\n  }\n\n  .common-nav__brand {\n    min-width: 0;\n    gap: 0;\n  }\n\n  .common-nav__logo-slot {\n    width: 88px;\n    height: 76px;\n    border-radius: 14px;\n  }\n\n  .common-nav__brand-text,\n  .common-nav__links {\n    display: none;\n  }\n\n  .common-nav__actions {\n    min-width: 0;\n    margin-left: auto;\n    display: flex;\n    justify-content: flex-end;\n  }\n\n  .common-nav__menu-btn {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 44px;\n    height: 44px;\n    border-radius: 10px;\n  }\n\n  .common-nav__overlay {\n    z-index: 1100;\n  }\n\n  .common-nav__drawer {\n    top: 0;\n    right: 0;\n    width: min(72vw, 280px);\n    z-index: 1200;\n    padding: 14px 14px 20px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
